<template>
  <div class="table-wrapper">
    <div class="table-header">
      <div>
        <button class="button button-secondary button-long">
          Inspection Schedules
        </button>
      </div>
      <div class="table-header__col-two">
        <div class="table__search-input-wrapper">
          <input
            type="text"
            class="table__search-input"
            placeholder="Search..."
          />
          <search-icon />
        </div>
      </div>
    </div>

    <table class="custom-table responsive-table">
      <thead>
        <tr>
          <th>Name</th>
          <th>VIN</th>
          <th>Vehicle Type</th>
          <th>Carriage Capacity</th>
          <th>Terminals</th>
          <th>Date Registered</th>
          <th>Inspection Date</th>
          <th>Vehicle Status</th>
        </tr>
      </thead>
      <tbody v-if="!loading && vehicles.length == 0">
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td>
            No vehicles to display!
          </td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      </tbody>
      <tbody v-if="!loading && vehicles.length">
        <tr v-for="vehicle in vehicles" :key="vehicle.id">
          <td>{{ vehicle.vehiclename }}</td>
          <td>{{ vehicle.vinnumber }}</td>
          <td>{{ vehicle.vehicletype }}</td>
          <td>{{ vehicle.loadingcapacity }}</td>
          <td>{{ vehicle.terminals ? "-" : "-" }}</td>
          <td>
            {{ new Date(vehicle.createdAt).toLocaleDateString("en-gb") }}
          </td>
          <td>-</td>
          <td>Active</td>
        </tr>
      </tbody>
    </table>

    <loader v-if="loading" />

    <pagination />
    <delete-modal
      :showModal="isDeleteModal"
      :itemToDelete="itemToDelete"
      :deletingItem="deletingVehicle"
      @close-modal="isDeleteModal = false"
      @delete-item="deleteVehicle"
    />
  </div>
</template>

<script>
import Pagination from "@/components/UI/pagination";
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      selectedRowId: null,
      loading: false,
      vehicles: [],
      isDeleteModal: false,
      itemToDelete: "Vehicle",
      selectedVehicleId: null,
      deletingVehicle: false,
    };
  },
  mounted() {
    this.getAllVehicles();
  },
  methods: {
    async getAllVehicles() {
      this.loading = true;
      try {
        let response = await this.$_getAllVehicles();
        console.log(response);
        this.vehicles = response.data.data;
        this.loading = false;
      } catch (error) {
        this.handleError(error);
        this.loading = false;
      }
    },
    async deleteVehicle() {
      this.deletingVehicle = true;
      try {
        await this.$_deleteVehicle(this.selectedVehicleId);
        this.generateToast("Vehicle successfully deleted!", "success");
        this.getAllVehicles();
        this.deletingVehicle = false;
        this.isDeleteModal = false;
      } catch (error) {
        this.handleError(error);
        this.deletingVehicle = false;
      }
    },
    showDeleteModal(vehicleId) {
      this.selectedVehicleId = vehicleId;
      this.isDeleteModal = true;
    },
    showActionOptions(id) {
      if (!this.selectedRowId) {
        this.selectedRowId = id;
      } else {
        this.selectedRowId = null;
      }
    },
    viewSingleVehicle(vehicleId) {
      localStorage.setItem("vehicleId", vehicleId);
      this.$router.push({ name: "SingleVehicle" });
    },
    resetSelectedRow() {
      this.selectedRowId = null;
    },
  },
};
</script>

<style scoped>
.table-wrapper {
  margin: 3rem 0;
}
.table-header {
  display: flex;
  justify-content: space-between;
}
.table-header__col-two {
  display: flex;
}
.table__btn {
  padding: 0.45rem 0.85rem;
  color: #ffffff;
  font-size: 0.85rem;
  border-radius: 3px;
}
.table__search-input-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f0f2f1;
  height: 2.25rem;
  width: 30vw;
  border-radius: 15px;
  padding: 0 1rem;
  margin-right: 1.5rem;
}
.table__search-input {
  background: transparent;
  color: #343633;
  font-size: 0.9rem;
  width: 100%;
  height: 100%;
}
.table__search-input:focus {
  outline: none;
}
.table__search-input::placeholder {
  color: #343633;
  font-size: 0.9rem;
}
.custom-table {
  margin: 2rem 0;
  width: 100%;
}
.custom-table tr {
  border-bottom: 1px solid #d5d5d5;
}
.custom-table th {
  color: #060e18;
  font-weight: 600;
}
.custom-table th,
td {
  padding: 1rem;
  font-size: 0.9rem;
}
.custom-table td {
  color: #343633;
}
.table__action-btn {
  position: relative;
  padding: 0;
}
.table__action-options {
  position: absolute;
  width: 8rem;
  padding: 0.5rem 0;
  right: 2rem;
  background: #ffffff;
  z-index: 999;
  border-radius: 3px;
  box-shadow: 0px 0px 12px #dee0e7;
}
.table__action-option {
  padding: 0.5rem 0.75rem;
  font-size: 0.9rem;
}
.table__action-option:hover {
  background: #fce4da;
}
.table__action-btn span {
  width: 100%;
}
@media screen and (max-width: 768px) {
  .table__search-input-wrapper {
    width: 100%;
  }
  .table__btn-wrapper {
    width: 100%;
  }
  .button {
    width: 100%;
    margin-bottom: 1rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .table-header__col-two {
    flex-direction: column-reverse;
  }
}
</style>
